module.exports = "<lost-page></lost-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/lostView.html
// module id = 2122
// module chunks = 0